import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

defineMessages({
  COPYRIGHT: {
    id: 'COPYRIGHT',
    description: 'Copyright notice.',
    defaultMessage: 'Part of {comscoreFooterText}. ©{year} BuzzFeed, Inc. All rights reserved.',
  },
});

const classWithModifiers = (base, modifiers = []) => {
  const classArray = modifiers.filter((m) => m).map((m) => `${base}--${m}`);
  classArray.unshift(base);
  return classArray.join(' ');
};

const maybeLinkTo = (url, condition, attributes, innerHTML) => (condition
  ? <a href={url} {...attributes}>{innerHTML}</a>
  : innerHTML);

const MaybeWrapElement = ({
  condition, wrap, children, wrapElse,
}) => {
  if (condition) {
    return (wrap(children));
  }

  return (wrapElse ? wrapElse(children) : children);
};

const footerText = (comscoreFooterText) => (
  <FormattedMessage
    id="COPYRIGHT"
    values={{
      comscoreFooterText,
      year: (new Date()).getFullYear(),
    }}
  />
);

export {
  classWithModifiers,
  maybeLinkTo,
  MaybeWrapElement,
  footerText,
};
